
<script setup>
import { ref, onMounted, onBeforeUnmount } from "vue";
import api from '@/api';

const totalAsistencias = ref(0);
let intervalId = null;

const fetchAsistencias = async () => {
  try {
    const response = await api.get("/accesos/asistencias-hoy"); 
    totalAsistencias.value = response.data.total;
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') console.error("Error al cargar asistencias:", error);
  }
};

onMounted(() => {
  fetchAsistencias();
  intervalId = setInterval(fetchAsistencias, 10000);
});

onBeforeUnmount(() => {
  if (intervalId) clearInterval(intervalId);
});
</script>

<template>
  <div class="card z-index-2">
    <div class="card-header pb-0">
      <h6>Asistencias de hoy</h6>
      <p class="text-sm">
        <i class="fa fa-sync text-success"></i>
        Actualizado en tiempo real
      </p>
    </div>
    <div class="card-body d-flex justify-content-center align-items-center" style="height: 150px;">
      <h1 class="display-4">{{ totalAsistencias }}</h1>
    </div>
  </div>
</template>

